var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIconYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 25,
    rx: 3.5,
    fill: "#FFEED9",
    stroke: "#FF8A2C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00747 22L10.6881 19.1898C10.6881 19.1898 19.2333 7.56217 19.7674 6.83187C20.3015 6.10514 19.7599 5.50014 19.6778 5.44644C19.5956 5.39274 16.477 3.28774 16.2119 3.10875C15.9467 2.92975 15.4425 2.90469 14.9532 3.5634C14.4677 4.22568 5.87394 15.9213 5.87394 15.9213L5 22H5.00747Z",
    stroke: "#FF8A2C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 10L8 18",
    stroke: "#FF8A2C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 11L12 8",
    stroke: "#FF8A2C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 9L13 6",
    stroke: "#FF8A2C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 19L6 16",
    stroke: "#FF8A2C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconYellow);
export default __webpack_public_path__ + "static/media/EditIconYellow.9714db740450c17db968fa7df234dff6.svg";
export { ForwardRef as ReactComponent };